import React from "react"
import PropTypes from "prop-types"
import { Dropdown } from "antd"
import { Icon } from "ui/Icon"
import styles from "./index.module.css"

/**
 * The bordered pill that opens one filter's panel. `count` renders the applied-selection badge,
 * which is also what tells the guide a filter is narrowing the list once its panel is closed.
 */
const FilterPill = ({ label, iconName, count = 0, isActive = false, isOpen, onOpenChange, children }) => (
  <Dropdown
    open={isOpen}
    onOpenChange={onOpenChange}
    trigger={["click"]}
    placement="bottomLeft"
    dropdownRender={() => children}
  >
    <button type="button" className={`${styles.pill} ${isActive || count ? styles.pillActive : ""}`}>
      {iconName && <Icon name={iconName} width={20} height={20} color="var(--color-text-primary)" />}
      <span className={styles.pillLabel}>{label}</span>
      {count > 0 && <span className={styles.pillCount}>{count}</span>}
      <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} width={16} height={16} color="var(--color-text-primary)" />
    </button>
  </Dropdown>
)

FilterPill.propTypes = {
  label: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  count: PropTypes.number,
  /** Highlights the pill without a numeric badge — used by the date range, which shows its dates. */
  isActive: PropTypes.bool,
  isOpen: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

export default FilterPill
